import { FundaeFinishGroupDatatableQuery } from 'generated/resources/datatable.graphql'

import Callout from 'modules/core/components/Callout'
import { useDataTable } from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

export function PermissionCallout() {
  const missingPermissions = useMissingPermissions()
  if (missingPermissions.length === 0) return <></>
  return (
    <Callout
      type="critical"
      title={i18n.t(
        'trainings.trainings_detail.fundae.participants_datatable.permission_callout.title'
      )}
      description={`${i18n.t(
        'trainings.trainings_detail.fundae.participants_datatable.permission_callout.description'
      )} ${missingPermissions.join(', ')} `}
    />
  )
}

function useMissingPermissions() {
  const { data } = useDataTable<FundaeFinishGroupDatatableQuery>()
  return Object.entries(
    data
      .map((participant) => {
        return {
          seeExtraInfo: !participant.access.employee.referenceContract._policies.seeExtraInfo.can,
          editContract: !participant.access.employee.referenceContract._policies.edit.can,
          seePersonalInfo: !participant.access.employee._policies.readPersonalInfo.can,
          editPersonalInfo: !participant.access.employee._policies.editPersonalInfo.can,
        }
      })
      .reduce(
        (acc, item) => {
          return {
            seeExtraInfo: acc.seeExtraInfo || item.seeExtraInfo,
            editContract: acc.editContract || item.editContract,
            seePersonalInfo: acc.seePersonalInfo || item.seePersonalInfo,
            editPersonalInfo: acc.editPersonalInfo || item.editPersonalInfo,
          }
        },
        {
          seeExtraInfo: false,
          editContract: false,
          seePersonalInfo: false,
          editPersonalInfo: false,
        }
      )
  )
    .filter(([_, missing]) => missing)
    .map(([key]) => permissionI18n(key))

  function permissionI18n(key: string) {
    switch (key) {
      case 'seeExtraInfo': {
        return i18n.t(
          'trainings.trainings_detail.fundae.participants_datatable.permission_callout.permissions.see_extra_info'
        )
      }
      case 'editContract': {
        return i18n.t(
          'trainings.trainings_detail.fundae.participants_datatable.permission_callout.permissions.edit_contract'
        )
      }
      case 'seePersonalInfo': {
        return i18n.t(
          'trainings.trainings_detail.fundae.participants_datatable.permission_callout.permissions.see_personal_info'
        )
      }
      case 'editPersonalInfo': {
        return i18n.t(
          'trainings.trainings_detail.fundae.participants_datatable.permission_callout.permissions.edit_personal_info'
        )
      }
      default: {
        throw new Error(`Unkown permission name. ${key}`)
      }
    }
  }
}
